import React, { useEffect, useState } from "react";
import _ from "lodash";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import Text from "theme/Text";
import ObjectLunchOption from "utils/objects/lunch-option";
import ThemedSelect from "components/atoms/ThemedSelect";
import { constantsActive } from "utils/constants/constants";
import HelperString from 'utils/helper-string'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'

const SelectLunch = ({ item = {}, options, building = {}, floor = {}, room = {}, select, selected, enableDefaultSelected = true }) => {
	
	const _lunchOptions = useSelector( state => {
		return state.data[dataConstants.LUNCH_OPTIONS];
	} )
	
	const [ loading, setLoading ] = useState( true )
	const [ defaultSelected, setDefaultSelected ] = useState( null )
	const [ lunchOptions, setLunchOptions ] = useState( [] )
	
	const onSelect = ( selected ) => {
		if( select && _.isFunction( select ) ) {
			select( {
				item: item,
				selected: selected
			} );
		}
	}
	
	useEffect(() => {
		// Get all the lunch options
		const newLunchOptions = options ? options : ObjectLunchOption.getOptions( {
			building: building,
			floor: floor,
			room: room,
		} );
		
		// Check the default selected option
		let defaultSelected = null;
		_.forEach( newLunchOptions, lunchOption => {
			lunchOption['translation_title'] = Translate.field( lunchOption, 'title' );
			
			if( enableDefaultSelected && lunchOption['default'] === constantsActive.YES ) {
				defaultSelected = lunchOption['guid'];
			}
		});
		
		// If we found a default selected option, trigger the selct
		if( defaultSelected !== null && selected === null ) {
			onSelect( defaultSelected );
		}
		
		setLoading( false )
		setDefaultSelected( defaultSelected )
		setLunchOptions( newLunchOptions )
	}, [ options, _lunchOptions ] )
	
	if( loading ) {
		return ( <></> )
	}
	
	const selectProps = {};
	if( defaultSelected !== null ) {
		selectProps['placeholder'] = null;
	}
	
	if( _.isEmpty( lunchOptions ) ) {
		return (
			<Text
				category={"label"}>
				
				{ i18n.t('form.fields.lunch_option.not_available') }
			</Text>
		);
	}
	
	const selectOptions = (
		_.map( lunchOptions, lunchOption => {
			return (
				{
					value:   lunchOption.guid,
					label: lunchOption.translation_title
				}
			);
		})
	)
	
	return (
		<ThemedSelect
			key={ HelperString.hash( 'lunch-option-select', item ) }
			{ ...selectProps }
			options={ selectOptions }
			selected={ selected ? selected : defaultSelected }
			select={ onSelect }
		/>
	);
}

export default SelectLunch
